const storageKey = (uid: string) => `linkpark.push-opt-in.dismissed.${uid}`;

export function wasPushOptInDismissed(uid: string): boolean {
  try {
    return localStorage.getItem(storageKey(uid)) === '1';
  } catch {
    return false;
  }
}

export function dismissPushOptIn(uid: string): void {
  try {
    localStorage.setItem(storageKey(uid), '1');
  } catch {
    /* private mode */
  }
}
